import React from "react";
import PropTypes from "prop-types";

class Input extends React.Component {
  _handleKeyPress = (e) => {
    const { onPressEnter } = this.props;
    if (onPressEnter && e.key === "Enter") {
      onPressEnter();
    }
  };

  selectAll = (event) => event.target.select();

  _handleKeyDown = (e) => {
    const { onPressEscape, onCtrlDown, onCtrlUp } = this.props;
    if (onPressEscape && e.keyCode === 27) {
      onPressEscape();
    }

    console.log(e.keyCode);

    if (e.ctrlKey && e.keyCode === 40) {
      console.log("Ctrl + Down pressed");
      onCtrlDown && onCtrlDown();
    } else if (e.ctrlKey && e.keyCode === 38) {
      console.log("Ctrl + Up pressed");
      onCtrlUp && onCtrlUp();
    }
  };

  componentDidMount = () => {
    const { focus } = this.props;
    if (focus) this._input.focus();
  };

  render() {
    const {
      onPressEnter,
      onPressEscape,
      focus,
      onFocus,
      selectAllOnFocus,
      ...otherProps
    } = this.props;
    return (
      <input
        ref={(ref) => (this._input = ref)}
        type="text"
        {...otherProps}
        onKeyDown={this._handleKeyDown}
        onKeyPress={this._handleKeyPress}
        onFocus={selectAllOnFocus ? this.selectAll : onFocus}
      />
    );
  }
}

export default Input;

Input.propTypes = {
  onPressEnter: PropTypes.func,
  focus: PropTypes.bool,
};
